export const getFilenameFromUrl = (url?: string | null): string => {
	if (!url) return 'Unknown file'

	try {
		const pathname = new URL(url).pathname
		const parts = pathname.split('/').filter(Boolean)
		return parts[parts.length - 1] || url
	} catch {
		const parts = url.split('/').filter(Boolean)
		return parts[parts.length - 1] || url
	}
}

export const getViewableUrl = (url: string) => {
	const isOfficeDocument = /\.(docx?|xlsx?|pptx?)(\?|#|$)/i.test(url)
	if (isOfficeDocument) {
		return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`
	}

	return url
}

export const openFilePreview = (url: string) => {
	window.open(getViewableUrl(url), '_blank', 'noopener,noreferrer')
}

export const downloadFileUrl = (url: string) => {
	const link = document.createElement('a')
	link.href = url
	link.target = '_blank'
	link.rel = 'noreferrer'
	link.download = ''
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}
